module.exports = (__webpack_require__(6))(98);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/webpack/buildin/global.js from dll-reference vendor_aa0bb54e7e791c5951ff
// module id = 295
// module chunks = 0 1 2